<template>
	<section class="page page-notfound">
		<h1>Page not found</h1>
	</section>
</template>

<script lang="ts">
	import PageBase from '@/Core/Page.vue';
	import { Component } from 'vue-property-decorator';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package Page
	 * @project ChalkySticks App
	 */
	@Component
	export default class PageNotFound extends PageBase {
		// Not implemented
	}
</script>
